
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.6 8.304l10.8 6.121a1.218 1.218 0 001.2 0l10.8-6.121a1.19 1.19 0 00.437-.428 1.16 1.16 0 00-.438-1.609L12.6.157a1.218 1.218 0 00-1.2 0L.6 6.268a1.189 1.189 0 00-.44.433A1.16 1.16 0 00.6 8.304zM12 2.583l8.4 4.708L12 12 3.6 7.291 12 2.583zm10.2 8.44L12 16.709 1.8 10.976a1.214 1.214 0 00-1.644.435c-.156.27-.197.59-.114.89.083.3.284.556.558.711l10.8 6.122a1.218 1.218 0 001.2 0l10.8-6.122a1.18 1.18 0 00.558-.71 1.157 1.157 0 00-.423-1.239 1.209 1.209 0 00-.89-.236c-.157.02-.308.071-.445.149v.047zm0 4.709L12 21.417 1.8 15.684a1.216 1.216 0 00-1.644.436c-.156.27-.197.59-.114.89.083.3.284.556.558.711l10.8 6.121a1.218 1.218 0 001.2 0l10.8-6.121a1.18 1.18 0 00.558-.71 1.157 1.157 0 00-.423-1.24 1.209 1.209 0 00-.89-.235c-.157.02-.308.07-.445.149v.047z"}})])
          )
        }
      }
    